// extracted by mini-css-extract-plugin
export default {"volunteer-page":"VolunteerPage_volunteer-page__RnabS","volunteers-title":"VolunteerPage_volunteers-title__MsfJY"};